import SubmissionError from "../../../../error/SubmissionError";
import fetch from '../../../../utils/fetch';

const getInitialState = () => {
  return {
    upload: {
      // status
      // isUploading, success, error

      // '@id'
      // either server side uuid or initial id

      // blob
      // will be converted to appropriate file for upload

      // path
      // path for file

      // action_type
      // upload type

      // objectID
      // object that this file object is going to associate with
    },
    uploadTemplate: {
      status: null,
      error: null,
      '@id': null,
      blob: null,
      path: null,
      action_type: null,
    },
    isLoading: false,
    avatar: null,
    error: null,
  }
}

const state = getInitialState();

const FILE_STATUS = {
  IS_UPLOADING: "IS_UPLOADING",
  ERROR: "ERROR",
  SUCCESS: "SUCCESS",
}

const ACTION_TYPES = {
  // currently supported action types by this store
  avatar: {
    name: "avatar",
    dbname: "picture",
    extensions: ["jpg", "jpeg", "png", "heic", "heif", "webp"],
  },
}

const actions = {

  get({commit, rootGetters}) {
    commit(types.RESET)
    commit(types.SET_AVATAR_LOADING)
    // if (rootGetters['user/profile/picture']) {
      commit(types.SET_AVATAR, rootGetters['user/profile/picturePath'])
    // } else {
    //   commit(types.SET_AVATAR, null)
    // }
  },

  remove({commit, dispatch, rootGetters}) {
    commit(types.SET_AVATAR_LOADING)
    return fetch(rootGetters['user/profile/picture']['@id'], {method: 'DELETE'})
      .then((response) => {
        return response.status === 204
      })
      .then((isDeleted) => {
        if (isDeleted) {
          dispatch('user/profile/fetchSession', null, {root: true});
        } else {
          commit(types.SET_AVATAR_ERROR, 'Error removing profile image')
        }
      })
      .catch((e) => {
        commit(types.SET_AVATAR_ERROR, e.message)
      })
  },

  // Upload a user profile image
  async upload({commit, state, dispatch, rootGetters}, filePayload) {
    // Check if ACTION_TYPE is set
    if (!filePayload.type && !ACTION_TYPES[fileObject.type]) {
      console.log('actionType not set or incorrect.')
      return
    }

    commit(types.SET_AVATAR_LOADING)
    const fileObject = {
      blob: filePayload.file,
      name: filePayload.name,
      type: 'avatar',
    }
    // build form data
    const formData = new FormData()
    formData.append('file', fileObject.blob, fileObject.name)
    formData.append('actionType', ACTION_TYPES[fileObject.type].name)

    let url = '/file_objects'
    // If an avatar exists, replace it instead of creating a new one
    if (rootGetters['user/profile/picture']) {
      url = rootGetters['user/profile/picture']['@id']
    }

    return fetch(url, {method: 'POST', body: formData})
      .then((response) => {
        return response.json()
      }).then((data) => {
        // Update the user avatar in Vuex state directly for reactivity
        commit('user/profile/UPDATE_USER_AVATAR', data, { root: true })
        // Update local avatar state
        commit(types.SET_AVATAR, data.path)
        return data
      }).catch((error) => {
        commit(types.SET_AVATAR_ERROR, {error, name: fileObject.name, type: fileObject.type})
      })
  },
}

const getters = {
  isLoading(state) {
    return state.isLoading
  },
  image(state) {
    return state.avatar
  },
  imagePresent(state) {
    return state.avatar !== "/assets/images/default_avatar.png";
  },
  avatarExtensions() {
    return ACTION_TYPES.avatar.extensions
  }
}

export const types = {
  SET_AVATAR_LOADING: "SET_AVATAR_LOADING",
  SET_AVATAR: "SET_AVATAR",
  SET_AVATAR_ERROR: "SET_AVATAR_ERROR",
  RESET: "RESET",
}

const mutations = {
  [types.SET_AVATAR_LOADING](state) {
    state.isLoading = true
  },

  [types.SET_AVATAR](state, avatar) {
    state.avatar = avatar
    state.isLoading = false
  },
  [types.SET_AVATAR_ERROR](state, payload) {
    state.error = payload.error instanceof SubmissionError ? payload.errors._error : payload.error.message
    state.isLoading = false
  },
  [types.RESET](state) {
    Object.assign(state, getInitialState());
  },
}

export default {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations,
}
